var _style, _filter, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmsNonCustom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 23",
    width: 28,
    height: 23,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "smsIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #068b14 } \r\n\t")), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "f0"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffffff",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder 1",
    filter: "url(#f0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m21.8 21.6l-6-5h-8.3c-2.8 0-5-2.3-5-5.1v-5c0-2.8 2.2-5.1 5-5.1h13c2.8 0 5 2.3 5 5.1v5c0 2.4-1.6 4.3-3.7 5zm-14.3-18.7c-1.9 0-3.6 1.7-3.6 3.6v5c0 2 1.7 3.7 3.6 3.7h8.8l3.9 3.3v-3.3h0.7c1.8-0.3 3.2-1.8 3.2-3.7v-5c0-1.9-1.7-3.6-3.6-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m6.6 9.8c0.3 0.3 0.8 0.4 1.2 0.4 0.5 0 0.6-0.1 0.6-0.4 0-0.2-0.1-0.3-0.6-0.5-0.9-0.2-1.3-0.7-1.3-1.4 0-0.7 0.8-1.4 1.8-1.4 0.5 0 1 0.1 1.2 0.3l-0.2 1c-0.1-0.1-0.5-0.3-0.9-0.3q-0.5 0-0.6 0.3c0 0.2 0.2 0.4 0.7 0.5 0.9 0.4 1.3 0.8 1.3 1.4 0 0.9-0.8 1.5-2 1.5-0.5 0-1.1-0.1-1.4-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m10.6 8q0-0.8 0-1.4h1.1l0.1 0.7c0.2-0.4 0.5-0.8 1.3-0.8 0.6 0 1.2 0.3 1.3 0.8q0.2-0.4 0.6-0.5 0.4-0.3 0.8-0.3c0.9 0 1.5 0.7 1.5 1.9v2.7h-1.3v-2.4c0-0.7-0.2-1-0.7-1-0.3 0-0.5 0.1-0.7 0.5v0.2 2.7h-1.4v-2.5c0-0.6-0.1-0.9-0.6-0.9-0.3 0-0.5 0.2-0.6 0.5q0 0.1 0 0.2v2.7h-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m18.5 9.8c0.2 0.3 0.7 0.4 1.1 0.4 0.4 0 0.6-0.1 0.6-0.4 0-0.2-0.1-0.3-0.6-0.5-1-0.2-1.3-0.7-1.3-1.4 0-0.7 0.7-1.4 1.8-1.4 0.5 0 1 0.1 1.3 0.3l-0.3 1c-0.2-0.1-0.6-0.3-1-0.3q-0.5 0-0.5 0.3c0 0.2 0.3 0.4 0.8 0.5 0.7 0.4 1.1 0.8 1.1 1.4 0 0.9-0.6 1.5-1.9 1.5-0.5 0-1.1-0.1-1.4-0.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsNonCustom);
export default __webpack_public_path__ + "static/media/smsNonCustom.c8bda42a0ae23ab5b6f77600da5585ea.svg";
export { ForwardRef as ReactComponent };